import PropTypes from "prop-types";
import React from "react";

import { BulletList, Section } from "@swa-ui/core";
import { CheckboxFormField, useFormContext } from "@swa-ui/form";
import i18n from "@swa-ui/locale";

import { PlacementInfoLabel } from "../PlacementInfoLabel";
import styles from "./OtherAssistanceFormFields.module.scss";
import { OTHER_ASSISTANCE_SCHEMA_FIELD_NAMES } from "./OtherAssistanceFormFields.schema";

const { PORTABLE_OXYGEN_CONCENTRATOR, PEANUT_ALLERGY } = OTHER_ASSISTANCE_SCHEMA_FIELD_NAMES;

export const OtherAssistanceFormFields = (props) => {
  const {
    peanutAllergyAssistanceFieldName = PEANUT_ALLERGY,
    oxygenConcentratorAssistanceFieldName = PORTABLE_OXYGEN_CONCENTRATOR,
  } = props;
  const { watch } = useFormContext();
  const oxygenConentratorAssistanceSelected = watch(oxygenConcentratorAssistanceFieldName);

  return (
    <Section {...getSectionProps()}>
      {renderOptions()}
      {renderOxygenConcentratorSubtext()}
    </Section>
  );

  function renderOptions() {
    const options = [
      {
        infoPlacementId: "disabilityOptionPeanut",
        label: "OtherAssistanceFormField__PEANUT_ALLERGY",
        name: peanutAllergyAssistanceFieldName,
      },
      {
        infoPlacementId: "disabilityOptionOxygen",
        label: "OtherAssistanceFormField__PORTABLE_OXYGEN_CONCENTRATOR",
        name: oxygenConcentratorAssistanceFieldName,
      },
    ];

    return options.map((option) => (
      <CheckboxFormField {...getCheckboxFormFieldProps(option)} key={option.name} />
    ));
  }

  function renderOxygenConcentratorSubtext() {
    return oxygenConentratorAssistanceSelected && <BulletList {...getBulletListProps()} />;
  }

  function getSectionProps() {
    return {
      headingProps: {
        bottomSpacing: "small",
        children: i18n("OtherAssistanceFormField__HEADER"),
        headingLevel: 2,
        styleLevel: 5,
        topSpacing: "medium",
      },
    };
  }

  function getCheckboxFormFieldProps(option) {
    const { infoPlacementId, label, name } = option;

    return {
      className: styles.checkboxFormField,
      componentProps: { label: <PlacementInfoLabel label={label} placementId={infoPlacementId} /> },
      hideBottomSection: true,
      name,
    };
  }
  function getBulletListProps() {
    return {
      animateInitialRender: true,
      icon: { name: "Bullet", size: "14" },
      itemClassName: styles.oxygenDevicesDisclaimer,
      items: [
        { content: i18n("OtherAssistanceFormField__OXYGEN_DEVICES_SUBTEXT") },
        { content: i18n("OtherAssistanceFormField__APPROVED_DEVICES_SUBTEXT") },
      ],
      spacing: "small",
    };
  }
};

export const otherAssistanceFormFieldsPropTypes = {
  /** Field name for bringing own oxygen conecntrator assistance checkbox. */
  oxygenConcentratorAssistanceFieldName: PropTypes.string,

  /** Field name for peanut allergy assistance checkbox. */
  peanutAllergyAssistanceFieldName: PropTypes.string,
};

OtherAssistanceFormFields.propTypes = otherAssistanceFormFieldsPropTypes;
